import { Box } from '@mui/material';
import React from 'react';

const DetailsHeader = () => {
  return (
    <Box className=" mt-1 w-[max-content] h-[50px] flex items-center border-t-2 shadow-lg border-l-2 border-b-2 rounded-md">
      <div className="w-[50px] border-r-2 h-full flex items-center  justify-center bg-[#f3f6f8] text-[16px] capitalize">
        Volet{' '}
      </div>
      <div className="ml-4 text-center w-[180px] border-r-2  h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
        N°indic. PROG
      </div>
      <div className="w-[220px] border-r-2   flex-col pl-[2px] h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
        Indicateur PROGRAMME
      </div>
      <div className="w-[280px] border-r-2  flex-col pl-[2px] h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
        Source de vérification de l'indicateur VOLET{' '}
      </div>
      <div className="w-[180px] border-r-2  text-[#0099F2] flex-col pl-[2px] h-full flex items-center  justify-center bg-[#f3f6f8] text-xs capitalize">
        Contribution à SNTE{' '}
      </div>
      <div className="w-[430px] ml-2 border-r-2  flex-col pl-[2px] h-full flex items-center  justify-center bg-[#f3f6f8] text-lg capitalize">
        Intitulé contractuel du cadre logique
      </div>
    </Box>
  );
};

export default DetailsHeader;
